import { createAsyncThunk } from '@reduxjs/toolkit';

import { deleteDoc, deleteAttachedDocFile } from '../document/document.middleware';
import api, { AppDocument } from 'api';

export const loadDocs = createAsyncThunk(
    'api/applications/{candidate_id}/documents',
    async (appId: string) => await api.application.documents.get(appId)
);

export const deleteDocs = createAsyncThunk(
    'DELETE/docs',
    async (docs: AppDocument[], { dispatch }) => {
        const requests = docs.map((doc) => {
            if (doc.resource_name && doc.resource_name.length > 0) {
                return dispatch(deleteAttachedDocFile(doc.id.toString()));
            }
            return dispatch(
                deleteDoc({ appID: doc.application_id.toString(), docID: doc.id.toString() })
            );
        });

        // return Promise.allSettled(requests);
        const multiplyRequest = await Promise.allSettled(requests);
        // return multiplyRequest.filter((val): val is PromiseFulfilledResult<any> => val.status === 'fulfilled').map(val => val.value)
        return multiplyRequest;
    }
);
